import React from 'react';
import PropTypes from 'prop-types';

import DimensionsContainer from './container';
import DimensionsLabel from './label';

import { SmartFillTooltip } from '../../orders/order-details/fulfillment-plan/sections/configure-shipment/smartfill-tooltip';
import { useIsLocalDeliveryServiceSelected } from '../hooks/use-is-local-delivery-service-selected';
import { useFulfillmentPlannerContext } from '../context';
import { emptyObject } from 'ui-components/default-props/empty';

const Size = ({ fulfillmentPlanId, classNames = emptyObject, shrinkable = false }) => {
  const { hasSmartFillDataBeenChanged, isSmartFillEnabled, smartFillMetaData } = useFulfillmentPlannerContext();

  const hasSmartFillDimensionsChanged =
    hasSmartFillDataBeenChanged?.height && hasSmartFillDataBeenChanged?.length && hasSmartFillDataBeenChanged?.width;
  const shouldShowSmartFillIcon = isSmartFillEnabled && !hasSmartFillDimensionsChanged;
  const isLocalDelivery = useIsLocalDeliveryServiceSelected();

  return (
    !isLocalDelivery && (
      <>
        <div className={classNames.label}>
          <SmartFillTooltip count={smartFillMetaData?.Height?.TimesUsed} shouldHideTooltip={!shouldShowSmartFillIcon}>
            <DimensionsLabel />
          </SmartFillTooltip>
        </div>
        <DimensionsContainer
          className={classNames.container}
          fulfillmentPlanId={fulfillmentPlanId}
          inputClassName={classNames['size-input']}
          shrinkable={shrinkable}
        />
      </>
    )
  );
};

Size.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  classNames: PropTypes.shape({
    label: PropTypes.string,
    'size-input': PropTypes.string,
    container: PropTypes.string,
  }),
  shrinkable: PropTypes.bool,
};

export default Size;
